import {
    createContext,
    FC,
    PropsWithChildren,
    ReactElement,
    useContext,
    useMemo,
} from 'react'

import { createFirebaseWebPushBridge } from '@/services/NativeBridge/FirebaseWebPushBridge'
import { createNativeAppWebViewBridge } from '@/services/NativeBridge/NativeAppWebViewBridge'
import { NativeBridge } from '@/types'

const NativeBridgeContext = createContext<NativeBridge | null>(null)

const createBridge = (): NativeBridge => {
    const nativeBridge = createNativeAppWebViewBridge()

    return nativeBridge.isAvailable ? nativeBridge : createFirebaseWebPushBridge()
}

export const NativeBridgeProvider: FC<PropsWithChildren> = ({ children }): ReactElement => {
    const bridge = useMemo(() => createBridge(), [])

    return (
        <NativeBridgeContext.Provider value={bridge}>
            {children}
        </NativeBridgeContext.Provider>
    )
}

export const useNativeBridge = (): NativeBridge => {
    const context = useContext(NativeBridgeContext)

    if (! context) {
        throw new Error('useNativeBridge must be used within a NativeBridgeProvider')
    }

    return context
}
